const form = document.getElementById('location-filter');
const filters = ['category', 'audience', 'city'];

function updateUrl() {
  const url = new URL(window.location.href);

  filters.forEach(filter => {
    const value = document.getElementById(filter).value;
    if (value) {
      url.searchParams.set(filter, value);
    } else {
      url.searchParams.delete(filter);
    }
  });

  window.history.pushState({}, '', url);
}

async function fetchLocations() {
  const params = new URLSearchParams({
    action: 'location_filter_results',
    nonce: themeData.nonce,
  });

  filters.forEach(filter => {
    const value = document.getElementById(filter).value;
    if (value) {
      params.set(filter, value);
    }
  });

  try {
    const response = await fetch(themeData.ajax_url + '?' + params.toString());
    if (!response.ok) {
      throw new Error('Request failed: ' + response.status);
    }
    document.getElementById('search-results').innerHTML = await response.text();
    updateUrl();
  } catch (error) {
    console.error('Filter error:', error);
  }
}

function getUrlFilterValues() {
  const url = new URL(window.location.href);

  filters.forEach(filter => {
    const value = url.searchParams.get(filter);
    if (value) {
      document.getElementById(filter).value = value;
    }
  });

  if (url.search !== '') {
    fetchLocations();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (form) {
    getUrlFilterValues();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      fetchLocations();
    });
  }
});
